import React, { useState } from "react";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogOverlay,
  DialogPortal,
} from "./ui/dialog";
import { Button } from "./ui/button";
import twoFA from "../assets/images/twoFA.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import TwoFA from "./MainTwoFA";
import withOverlay from "../hoc/withOverlay";

const TwoFAOverlay = withOverlay(TwoFA);

const EnableTwoFA = ({ open, setOpen, setIsTwoFAOpen, onClose }) => {
  const navigate = useNavigate();
  const handleTwoFactor = () => {
    return () => {
      setIsTwoFAOpen(true);
      setOpen(false);
    };
  };
  const handleDialogChange = (open) => {
    setOpen(open);

    onClose();
  };
  return (
    <>
      <Dialog open={open} onOpenChange={handleDialogChange}>
        <DialogPortal>
          <DialogOverlay className="bg-brand-primary/45 backdrop-blur-[4px] fixed inset-0" />
          <DialogContent>
            <div className="px-5">
              <div className="flex items-start justify-center ">
                <div>
                  <img src={twoFA} alt="" />
                </div>
              </div>
              <div className="text-center">
                <h3 className="text-2xl font-bold text-purple-700 mb-4">
                  Enable 2-Factor Authentication to transact
                </h3>
                <div className="text-gray-500">
                  80eight requires 2-Factor Authentication in order to keep your
                  account secure. By using an authenticator app, you ensure no
                  one else can log in and transact using your account.
                </div>
              </div>
              <div className="flex justify-center mt-4">
                <Button
                  className="py-5 px-20 text-sm font-bold text-white rounded-full bg-gradient-to-tr from-purple-500 to-rose-500 hover:opacity-90"
                  onClick={handleTwoFactor()}
                >
                  Enable 2-Factor Authentication
                </Button>
              </div>
            </div>
          </DialogContent>
        </DialogPortal>
      </Dialog>
    </>
  );
};

export default EnableTwoFA;
